import { moveToFulfilled, moveToPending, moveToRejected, update } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { GroupHeaderLoadAction } from '../../domains/groupHeaderLoad/actions.types';
import { GroupEditFulfilledAction } from '../../domains/groups/actions.types';

import { GroupDescriptionLabels } from './types';

export type GroupDescriptionLabelsAction = GroupHeaderLoadAction | GroupEditFulfilledAction;

const initialState: GroupDescriptionLabels = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<GroupDescriptionLabels, GroupDescriptionLabelsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP_HEADER.LOAD_PENDING':
      return moveToPending(state, [action.payload.groupId]);
    case 'GROUP_HEADER.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.groupId], action.payload.error);
    case 'GROUP_HEADER.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupDescriptionLabels);
    case 'GROUP.EDIT_FULFILLED':
      return update(
        state,
        action.payload.groupId,
        action.payload.entities.groupDescriptionLabels[action.payload.groupId]
      );
    default:
      return state;
  }
};

export default reducer;
